import { EnvValueSetting } from '@/modules/auth/models/interfaces/EnvValueSetting';
import { BaseEnv } from './Env.common';

class ViteEnv extends BaseEnv {
  nodeEnv(): ImportMetaEnv & EnvValueSetting {
    if (!this.computedEnv) {
      // @ts-ignore
      this.computedEnv = { ...(import.meta.env as ImportMetaEnv), ...this.env() };
    }

    return this.computedEnv!;
  }
}

export const Env: BaseEnv = new ViteEnv();
